import React,{useState,useEffect,useRef} from 'react'


function Support (props) {
 
    return (
        <div >
            <h1  style={{ padding:20 }}>Nox Calculator</h1>
            <img className="coming-img" src="/assets/images/under.jpg"></img>
</div>
 )
}


export default Support

